// extracted by mini-css-extract-plugin
export default {"cls1":"BbrPyosF1gAKgoVssXgB","cls2":"SwvKz_vB0jxKBtPiCwNi BbrPyosF1gAKgoVssXgB"};